import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX } = FiIcons;

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: "The Problem", href: "#problem" },
    { name: "What You Get", href: "#deliverables" },
    { name: "How It Works", href: "#process" },
    { name: "About", href: "#about" }
  ];

  return (
    <header className={`fixed top-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-navy/90 backdrop-blur-lg shadow-lg py-4 border-b border-white/10' : 'bg-transparent py-6'}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex justify-between items-center">
        <a href="#" className="flex flex-col z-50">
          <span className="font-extrabold text-xl md:text-2xl tracking-tight text-white">Local Trust & Visibility</span>
          <span className="text-[10px] md:text-xs text-teal-400 font-bold uppercase tracking-widest mt-0.5">Diagnostic Audit</span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <a key={link.name} href={link.href} className="text-sm font-semibold text-slate-300 hover:text-white transition-colors">
              {link.name}
            </a>
          ))}
          <a href="#book" className="bg-teal text-navy px-6 py-2.5 rounded text-sm font-bold hover:bg-teal-400 transition-all shadow-[0_0_15px_rgba(0,212,200,0.3)] hover:shadow-[0_0_25px_rgba(0,212,200,0.5)]">
            Book Your Audit
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden text-white p-2 z-50" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
          <SafeIcon icon={isMobileMenuOpen ? FiX : FiMenu} className="text-2xl" />
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="lg:hidden fixed inset-0 bg-navy/95 backdrop-blur-xl pt-24 px-6 flex flex-col z-40"
          >
            <div className="flex flex-col space-y-6 text-center">
              {navLinks.map((link) => (
                <a 
                  key={link.name} 
                  href={link.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="text-2xl font-bold text-white hover:text-teal transition-colors"
                >
                  {link.name}
                </a>
              ))}
              <a 
                href="#book"
                onClick={() => setIsMobileMenuOpen(false)}
                className="bg-teal text-navy px-6 py-4 rounded-md text-xl font-bold mt-8 shadow-[0_0_20px_rgba(0,212,200,0.4)]"
              >
                Book Your Audit Now
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;